import { defineComponent, ref, computed, markRaw, watch, nextTick, onMounted, onUnmounted, openBlock, createElementBlock, mergeProps, unref, createElementVNode, normalizeClass, createBlock, resolveDynamicComponent, createCommentVNode, renderSlot, toDisplayString, Fragment, renderList, withCtx, withModifiers, createVNode, normalizeStyle, Transition } from "vue";
import ChevronDownIcon from "../../assets/icons/chevron-down.svg.js";
import CloseIcon from "../../assets/icons/x-close.svg.js";
import Menu01StrokeRoundedIcon from "../../assets/icons/outline/menu-01-stroke-rounded.svg.js";
import { useScreenSize, breakpoints } from "../../composables/useScreenSize.js";
import Dropdown from "../dropdown/Dropdown.vue.js";
import DropdownItem from "../dropdown/DropdownItem.vue.js";
import NotificationBell from "../notification-bell/NotificationBell.vue.js";
import NotificationListItem from "../notification-bell/NotificationListItem.vue.js";
import ProfileDropdown from "../profile-dropdown/ProfileDropdown.vue.js";
const _hoisted_1 = { class: "app-header__container" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1,
  class: "app-header__mobile-title"
};
const _hoisted_4 = { class: "app-header__mobile-title-text" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "app-header__nav-text" };
const _hoisted_7 = { class: "app-header__nav-item nav-more-btn" };
const _hoisted_8 = { class: "app-header__nav-text" };
const _hoisted_9 = { class: "app-header__dropdown-item" };
const _hoisted_10 = { class: "app-header__notification-dropdown" };
const _hoisted_11 = { class: "app-header__notification-title" };
const _hoisted_12 = { class: "app-header__notification-list" };
const _hoisted_13 = {
  key: 0,
  class: "app-header__notification-empty"
};
const _hoisted_14 = {
  key: 0,
  class: "app-header__secondary"
};
const _hoisted_15 = { class: "app-header__secondary-container" };
const _hoisted_16 = ["onClick"];
const _hoisted_17 = { class: "app-header__secondary-text" };
const _hoisted_18 = { class: "app-header__secondary-item" };
const _hoisted_19 = { class: "app-header__secondary-text" };
const _hoisted_20 = { class: "app-header__dropdown-item" };
const _hoisted_21 = { class: "app-header__mega-menu" };
const _hoisted_22 = { class: "app-header__mega-menu-header" };
const _hoisted_23 = { class: "app-header__mega-menu-items" };
const _hoisted_24 = ["onClick"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ inheritAttrs: false },
  __name: "AppHeader",
  props: {
    logo: {},
    items: { default: () => [] },
    notificationItems: { default: () => [] },
    notificationBadgeCount: { default: 0 },
    showNotificationBadge: { type: Boolean, default: true },
    showDesktopNotification: { type: Boolean },
    maxVisibleItems: { default: 5 },
    maxVisibleSecondaryItems: { default: 5 },
    activeItem: {},
    activeSecondaryItem: {},
    currentPath: {},
    mobileShowMenuButton: { type: Boolean, default: false },
    mobileCompactHeader: { type: Boolean, default: false },
    mobileTitle: { default: "" },
    menuOpenTitle: {},
    showMenuButton: { type: Boolean, default: false },
    menuButtonLabel: { default: "More" },
    menuIcon: { default: void 0 },
    menuOpenIcon: {},
    preventMenuClose: { type: Boolean },
    profileAccounts: {},
    profileMenuItems: {},
    profileModelValue: {},
    profileSearchable: { type: Boolean },
    profileSearchPlaceholder: {},
    userName: {},
    userEmail: {},
    userAvatar: {},
    userDisplayMode: { default: "name" },
    isAdmin: { type: Boolean },
    showProfile: { type: Boolean, default: true },
    responsive: { type: Boolean, default: true }
  },
  emits: ["navigate", "navigateSecondary", "logoClick", "profile:select", "profile:update:modelValue", "menu-button-click", "notification:click", "notification:item-click"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const headerRef = ref(null);
    const logoRef = ref(null);
    const userRef = ref(null);
    const navRef = ref(null);
    const secondaryNavRef = ref(null);
    const visibleItems = ref([]);
    const dropdownItems = ref([]);
    const visibleSecondaryItems = ref([]);
    const dropdownSecondaryItems = ref([]);
    const pinnedPrimary = ref([]);
    const pinnedSecondary = ref([]);
    const internalActiveItem = ref(props.activeItem);
    const internalActiveSecondaryItem = ref(props.activeSecondaryItem);
    const isMenuOpen = ref(false);
    const mainHeaderHeight = ref(0);
    const secondaryHeaderHeight = ref(0);
    let observer = null;
    let headerObserver = null;
    const updateHeaderHeights = () => {
      if (headerRef.value) {
        const mainHeader = headerRef.value.querySelector(".app-header__container");
        if (mainHeader) {
          mainHeaderHeight.value = mainHeader.clientHeight;
        }
        const secondaryHeader = headerRef.value.querySelector(".app-header__secondary");
        if (secondaryHeader) {
          secondaryHeaderHeight.value = secondaryHeader.clientHeight;
        } else {
          secondaryHeaderHeight.value = 0;
        }
      }
    };
    const measureActualWidth = (items, isSecondary = false, forceShowMore = false) => {
      const container = isSecondary ? secondaryNavRef.value : navRef.value;
      if (!container) return 0;
      const overflowLabel = props.menuButtonLabel;
      const helper = document.createElement("div");
      const navStyle = window.getComputedStyle(container);
      helper.style.cssText = `
    display: flex; position: fixed; visibility: hidden; top: -9999px; white-space: nowrap;
    gap: ${navStyle.columnGap || navStyle.gap};
    padding: 0;
    font-family: ${navStyle.fontFamily};
    font-size: ${navStyle.fontSize};
    font-weight: ${navStyle.fontWeight};
  `;
      const createItem = (label, hasIcon, isOverflowTrigger = false) => {
        const btn = document.createElement("button");
        btn.className = isSecondary ? "app-header__secondary-item" : "app-header__nav-item";
        btn.style.display = "flex";
        btn.style.alignItems = "center";
        btn.style.gap = "8px";
        btn.style.padding = "12px 20px";
        btn.style.border = "none";
        btn.style.boxSizing = "border-box";
        btn.style.flexShrink = "0";
        if (isOverflowTrigger) {
          const spanEl = document.createElement("span");
          spanEl.textContent = overflowLabel;
          const divEl = document.createElement("div");
          divEl.style.cssText = "width:10px; height:6px; flex-shrink:0;";
          btn.appendChild(spanEl);
          btn.appendChild(divEl);
        } else {
          if (!isSecondary && hasIcon) {
            const iconEl = document.createElement("div");
            iconEl.style.cssText = "width:20px; height:20px; flex-shrink:0;";
            btn.appendChild(iconEl);
          }
          const spanEl = document.createElement("span");
          spanEl.textContent = label;
          btn.appendChild(spanEl);
        }
        return btn;
      };
      items.forEach((i) => helper.appendChild(createItem(i.label, !!i.icon)));
      if (forceShowMore) helper.appendChild(createItem(overflowLabel, true, true));
      document.body.appendChild(helper);
      const width = helper.getBoundingClientRect().width;
      document.body.removeChild(helper);
      return width;
    };
    const normalizeItemIcons = (items) => {
      return items.map((item) => ({
        ...item,
        icon: item.icon ? markRaw(item.icon) : void 0
      }));
    };
    const calculateLayout = (allItems, isSecondary = false) => {
      const navEl = isSecondary ? secondaryNavRef.value : navRef.value;
      if (!headerRef.value || !navEl || !allItems.length) return { visible: [], dropdown: [] };
      const navRect = navEl.getBoundingClientRect();
      const navStyle = window.getComputedStyle(navEl);
      const paddingX = parseFloat(navStyle.paddingLeft) + parseFloat(navStyle.paddingRight);
      const availableSpace = navRect.width - paddingX;
      const maxLimit = isSecondary ? props.maxVisibleSecondaryItems : props.maxVisibleItems;
      const pinned = isSecondary ? pinnedSecondary.value : pinnedPrimary.value;
      const pinnedNames = pinned.map((i) => i.name);
      const pinnedItems = allItems.filter((i) => pinnedNames.includes(i.name));
      const baseItems = allItems.filter((i) => !pinnedNames.includes(i.name)).slice(0, maxLimit);
      let visible = [...baseItems, ...pinnedItems];
      if (visible.length > allItems.length) visible = visible.slice(0, allItems.length);
      while (visible.length > 0) {
        const isShowingAll = visible.length === allItems.length;
        const currentTotalWidth = measureActualWidth(visible, isSecondary, !isShowingAll);
        if (currentTotalWidth <= availableSpace) break;
        if (baseItems.length > 0) {
          baseItems.pop();
          visible = [...baseItems, ...pinnedItems];
        } else {
          pinnedItems.shift();
          visible = [...baseItems, ...pinnedItems];
        }
      }
      const visibleNames = new Set(visible.map((v) => v.name));
      const dropdown = allItems.filter((item) => !visibleNames.has(item.name));
      return { visible, dropdown };
    };
    const updateAllLayouts = () => {
      const primary = calculateLayout(props.items, false);
      visibleItems.value = normalizeItemIcons(primary.visible);
      dropdownItems.value = normalizeItemIcons(primary.dropdown);
      const secondary = calculateLayout(currentSecondaryItems.value, true);
      visibleSecondaryItems.value = normalizeItemIcons(secondary.visible);
      dropdownSecondaryItems.value = normalizeItemIcons(secondary.dropdown);
    };
    const handleItemClick = (item) => {
      internalActiveItem.value = item.name;
      internalActiveSecondaryItem.value = "";
      const isInDropdown = dropdownItems.value.some((d) => d.name === item.name);
      if (isInDropdown) {
        pinnedPrimary.value = pinnedPrimary.value.filter((p) => p.name !== item.name);
        const testPinned = [...pinnedPrimary.value, item];
        pinnedPrimary.value = testPinned;
        nextTick(() => {
          const testLayout = calculateLayout(props.items, false);
          const fitsInVisible = testLayout.visible.some((v) => v.name === item.name);
          if (!fitsInVisible && visibleItems.value.length > 0) {
            const lastVisibleItem = visibleItems.value[visibleItems.value.length - 1];
            if (lastVisibleItem) {
              pinnedPrimary.value = pinnedPrimary.value.filter((p) => p.name !== lastVisibleItem.name);
            }
          }
          emit("navigate", item);
          nextTick(updateAllLayouts);
        });
      } else {
        emit("navigate", item);
        nextTick(updateAllLayouts);
      }
    };
    const handleSecondaryItemClick = (item) => {
      const parentItem = props.items.find((parent) => parent.secondaryItems?.some((sec) => sec.name === item.name));
      if (parentItem) {
        internalActiveItem.value = parentItem.name;
        const isParentInDropdown = dropdownItems.value.some((d) => d.name === parentItem.name);
        if (isParentInDropdown) {
          pinnedPrimary.value = pinnedPrimary.value.filter((p) => p.name !== parentItem.name);
          const testPinned = [...pinnedPrimary.value, parentItem];
          pinnedPrimary.value = testPinned;
          nextTick(() => {
            const testLayout = calculateLayout(props.items, false);
            const fitsInVisible = testLayout.visible.some((v) => v.name === parentItem.name);
            if (!fitsInVisible && visibleItems.value.length > 0) {
              const lastVisibleItem = visibleItems.value[visibleItems.value.length - 1];
              if (lastVisibleItem) {
                pinnedPrimary.value = pinnedPrimary.value.filter((p) => p.name !== lastVisibleItem.name);
              }
            }
            emit("navigate", parentItem);
            handleSecondaryPinning(item);
          });
        } else {
          emit("navigate", parentItem);
          handleSecondaryPinning(item);
        }
      } else {
        handleSecondaryPinning(item);
      }
      isMenuOpen.value = false;
    };
    const handleSecondaryPinning = (item) => {
      internalActiveSecondaryItem.value = item.name;
      nextTick(() => {
        updateAllLayouts();
        nextTick(() => {
          const isInDropdown = dropdownSecondaryItems.value.some((d) => d.name === item.name);
          if (isInDropdown) {
            pinnedSecondary.value = pinnedSecondary.value.filter((p) => p.name !== item.name);
            const testPinned = [...pinnedSecondary.value, item];
            pinnedSecondary.value = testPinned;
            nextTick(() => {
              const testLayout = calculateLayout(currentSecondaryItems.value, true);
              const fitsInVisible = testLayout.visible.some((v) => v.name === item.name);
              if (!fitsInVisible && visibleSecondaryItems.value.length > 0) {
                const lastVisibleItem = visibleSecondaryItems.value[visibleSecondaryItems.value.length - 1];
                if (lastVisibleItem) {
                  pinnedSecondary.value = pinnedSecondary.value.filter((p) => p.name !== lastVisibleItem.name);
                }
              }
              emit("navigateSecondary", item);
              nextTick(updateAllLayouts);
            });
          } else {
            emit("navigateSecondary", item);
            nextTick(updateAllLayouts);
          }
        });
      });
    };
    const toggleMenu = () => {
      emit("menu-button-click", isMenuOpen.value);
      if (props.preventMenuClose && isMenuOpen.value) {
        return;
      }
      isMenuOpen.value = !isMenuOpen.value;
    };
    const closeMenu = () => {
      isMenuOpen.value = false;
    };
    const currentActiveItem = computed(() => props.activeItem || internalActiveItem.value);
    const currentActiveSecondaryItem = computed(() => props.activeSecondaryItem || internalActiveSecondaryItem.value);
    const currentSecondaryItems = computed(() => {
      const activeRouteItem = props.items.find((item) => {
        if (item.name === currentActiveItem.value) return true;
        return item.secondaryItems?.some((s) => s.name === currentActiveSecondaryItem.value);
      });
      return activeRouteItem?.secondaryItems || [];
    });
    const groupedMenuItems = computed(() => {
      return props.items.map((parentItem) => ({
        category: parentItem.label,
        icon: parentItem.icon ? markRaw(parentItem.icon) : void 0,
        items: parentItem.secondaryItems || []
      })).filter((group) => group.items.length > 0);
    });
    const megaMenuStyles = computed(() => {
      const topOffset = mainHeaderHeight.value + secondaryHeaderHeight.value;
      return {
        blockSize: `calc(100dvh - ${topOffset + 20}px)`
      };
    });
    const { windowWidth } = useScreenSize();
    const isMobileViewport = computed(() => windowWidth.value < breakpoints.lg);
    const shouldShowMenuButton = computed(() => {
      if (props.mobileShowMenuButton) return isMobileViewport.value;
      return props.showMenuButton;
    });
    const isMobileCompactActive = computed(() => props.mobileCompactHeader && isMobileViewport.value);
    const handleUserInteractionCapture = (event) => {
      if (!shouldShowMenuButton.value) return;
      event.preventDefault();
      event.stopPropagation();
    };
    const resolvedMobileTitle = computed(() => {
      if (isMenuOpen.value && props.menuOpenTitle) return props.menuOpenTitle;
      return props.mobileTitle || props.userName || "";
    });
    const profileDisplayMode = computed(() => isMobileCompactActive.value ? "avatar" : props.userDisplayMode);
    const resolvedNotificationBadgeCount = computed(() => {
      if (props.notificationBadgeCount > 0) return props.notificationBadgeCount;
      return props.notificationItems.length;
    });
    const showDesktopNotification = computed(() => {
      if (props.showDesktopNotification !== void 0) {
        return props.showDesktopNotification;
      }
      return !isMobileViewport.value;
    });
    const notificationListTitle = computed(() => `Notifications (${props.notificationItems.length})`);
    const asNotificationRecord = (item) => {
      if (typeof item !== "object" || item === null) return {};
      return item;
    };
    const getRecordString = (record, keys) => {
      for (const key of keys) {
        const value = record[key];
        if (typeof value === "string") {
          const trimmedValue = value.trim();
          if (trimmedValue.length > 0) return trimmedValue;
        }
      }
      return "";
    };
    const getRecordBoolean = (record, keys) => {
      return keys.some((key) => record[key] === true);
    };
    const getNotificationInitials = (message) => {
      if (!message.trim()) return "N";
      const words = message.trim().split(/\s+/).filter((word) => word.length > 0);
      if (!words.length) return "N";
      if (words.length === 1) return words[0]?.slice(0, 1).toUpperCase() ?? "N";
      return `${words[0]?.slice(0, 1)}${words[1]?.slice(0, 1)}`.toUpperCase() ?? "N";
    };
    const notificationItemsViewModel = computed(() => {
      return props.notificationItems.map((item, index) => {
        const record = asNotificationRecord(item);
        const message = getRecordString(record, ["message", "title", "label", "content"]) || "Notification";
        const context = getRecordString(record, ["workspaceName", "organizationName", "organization", "context", "badge"]);
        const timeLabel = getRecordString(record, ["relativeTime", "timeLabel", "time", "ago"]);
        const avatarUrl = getRecordString(record, ["avatar", "avatarUrl", "image", "imageUrl"]);
        const isUnread = getRecordBoolean(record, ["unread", "isUnread"]) || record.status === "UNREAD";
        const isHighlighted = isUnread || record.isHighlighted === true;
        return {
          key: String(record.id ?? record.value ?? index),
          value: item,
          message,
          context,
          timeLabel,
          avatarUrl,
          initials: getNotificationInitials(message),
          isUnread,
          isHighlighted
        };
      });
    });
    const handleNotificationItemClick = (item) => {
      emit("notification:item-click", item);
    };
    const resolvedMenuIcon = computed(() => {
      if (isMenuOpen.value) {
        if (props.menuOpenIcon) return markRaw(props.menuOpenIcon);
        return markRaw(CloseIcon);
      }
      return markRaw(props.menuIcon ?? Menu01StrokeRoundedIcon);
    });
    watch(
      () => props.items,
      () => {
        pinnedPrimary.value = [];
        nextTick(() => {
          window.requestAnimationFrame(updateAllLayouts);
        });
        nextTick(updateHeaderHeights);
      },
      { deep: true }
    );
    watch(
      () => props.activeItem,
      (newVal) => {
        internalActiveItem.value = newVal;
      }
    );
    watch(
      () => props.activeSecondaryItem,
      (newVal) => {
        internalActiveSecondaryItem.value = newVal;
      }
    );
    watch(currentSecondaryItems, () => {
      updateAllLayouts();
      nextTick(updateHeaderHeights);
    });
    onMounted(() => {
      document.fonts.ready.then(() => {
        nextTick(() => {
          updateHeaderHeights();
          updateAllLayouts();
          if (window.ResizeObserver && headerRef.value) {
            observer = new ResizeObserver(() => {
              window.requestAnimationFrame(updateAllLayouts);
            });
            observer.observe(headerRef.value);
            headerObserver = new ResizeObserver(() => {
              updateHeaderHeights();
            });
            const mainContainer = headerRef.value.querySelector(".app-header__container");
            if (mainContainer) {
              headerObserver.observe(mainContainer);
            }
            const secondaryContainer = headerRef.value.querySelector(".app-header__secondary");
            if (secondaryContainer) {
              headerObserver.observe(secondaryContainer);
            }
          }
        });
      });
    });
    onUnmounted(() => {
      observer?.disconnect();
      headerObserver?.disconnect();
    });
    __expose({
      headerRef,
      logoRef,
      userRef,
      navRef,
      secondaryNavRef
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("header", mergeProps({
        ref_key: "headerRef",
        ref: headerRef,
        class: [
          "app-header",
          {
            "app-header--mobile-compact": unref(isMobileCompactActive)
          }
        ]
      }, _ctx.$attrs), [
        createElementVNode("div", _hoisted_1, [
          unref(shouldShowMenuButton) ? (openBlock(), createElementBlock("button", {
            key: 0,
            type: "button",
            class: normalizeClass(["app-header__menu-button", { "app-header__menu-button--active": unref(isMenuOpen) }]),
            onClick: toggleMenu
          }, [
            (openBlock(), createBlock(resolveDynamicComponent(unref(resolvedMenuIcon)), { class: "app-header__menu-icon" }))
          ], 2)) : createCommentVNode("", true),
          createElementVNode("button", {
            ref_key: "logoRef",
            ref: logoRef,
            type: "button",
            class: "app-header__logo",
            onClick: _cache[0] || (_cache[0] = ($event) => emit("logoClick"))
          }, [
            renderSlot(_ctx.$slots, "logo", {}, () => [
              __props.logo ? (openBlock(), createElementBlock("img", {
                key: 0,
                src: __props.logo,
                class: "app-header__logo-img"
              }, null, 8, _hoisted_2)) : createCommentVNode("", true)
            ], true)
          ], 512),
          unref(isMobileCompactActive) ? (openBlock(), createElementBlock("div", _hoisted_3, [
            createElementVNode("span", _hoisted_4, toDisplayString(unref(resolvedMobileTitle)), 1)
          ])) : createCommentVNode("", true),
          createElementVNode("nav", {
            ref_key: "navRef",
            ref: navRef,
            class: "app-header__nav"
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(visibleItems), (item) => {
              return openBlock(), createElementBlock("button", {
                key: item.name,
                class: normalizeClass(["app-header__nav-item", {
                  "app-header__nav-item--active": unref(currentActiveItem) === item.name
                }]),
                onClick: ($event) => handleItemClick(item)
              }, [
                item.icon ? (openBlock(), createBlock(resolveDynamicComponent(item.icon), {
                  key: 0,
                  class: "app-header__nav-icon"
                })) : createCommentVNode("", true),
                createElementVNode("span", _hoisted_6, toDisplayString(item.label), 1)
              ], 10, _hoisted_5);
            }), 128)),
            unref(dropdownItems).length ? (openBlock(), createBlock(Dropdown, { key: 0 }, {
              dropdown: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(dropdownItems), (item) => {
                  return openBlock(), createBlock(DropdownItem, {
                    key: item.name,
                    onClick: ($event) => handleItemClick(item)
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_9, [
                        item.icon ? (openBlock(), createBlock(resolveDynamicComponent(item.icon), {
                          key: 0,
                          class: "app-header__dropdown-icon"
                        })) : createCommentVNode("", true),
                        createElementVNode("span", null, toDisplayString(item.label), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]);
                }), 128))
              ]),
              default: withCtx(() => [
                createElementVNode("button", _hoisted_7, [
                  createElementVNode("span", _hoisted_8, toDisplayString(__props.menuButtonLabel), 1),
                  _cache[14] || (_cache[14] = createElementVNode("svg", {
                    class: "app-header__more-icon",
                    width: "10",
                    height: "6",
                    viewBox: "0 0 10 6",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    createElementVNode("path", {
                      d: "M8.75 0.75L4.75 4.75L0.75 0.75",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1))
                ])
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ], 512),
          unref(showDesktopNotification) ? (openBlock(), createElementBlock("div", {
            key: 2,
            class: "app-header__notification",
            onPointerdown: _cache[2] || (_cache[2] = withModifiers(() => {
            }, ["stop"])),
            onClick: _cache[3] || (_cache[3] = withModifiers(() => {
            }, ["stop"])),
            onMousedown: _cache[4] || (_cache[4] = withModifiers(() => {
            }, ["stop"])),
            onTouchstart: _cache[5] || (_cache[5] = withModifiers(() => {
            }, ["stop"])),
            onTouchend: _cache[6] || (_cache[6] = withModifiers(() => {
            }, ["stop"]))
          }, [
            createVNode(Dropdown, null, {
              dropdown: withCtx(() => [
                createElementVNode("div", _hoisted_10, [
                  createElementVNode("div", _hoisted_11, toDisplayString(unref(notificationListTitle)), 1),
                  createElementVNode("div", _hoisted_12, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(notificationItemsViewModel), (item) => {
                      return openBlock(), createBlock(DropdownItem, {
                        key: item.key,
                        value: item.value,
                        onClick: ($event) => handleNotificationItemClick(item.value)
                      }, {
                        default: withCtx(() => [
                          renderSlot(_ctx.$slots, "notificationItem", {
                            item: item.value
                          }, () => [
                            createVNode(NotificationListItem, { item }, null, 8, ["item"])
                          ], true)
                        ]),
                        _: 2
                      }, 1032, ["value", "onClick"]);
                    }), 128)),
                    !unref(notificationItemsViewModel).length ? (openBlock(), createElementBlock("div", _hoisted_13, " No notifications ")) : createCommentVNode("", true)
                  ])
                ])
              ]),
              default: withCtx(() => [
                createVNode(NotificationBell, {
                  "badge-count": unref(resolvedNotificationBadgeCount),
                  "show-badge": props.showNotificationBadge,
                  onClick: _cache[1] || (_cache[1] = ($event) => emit("notification:click"))
                }, null, 8, ["badge-count", "show-badge"])
              ]),
              _: 3
            })
          ], 32)) : createCommentVNode("", true),
          createElementVNode("div", {
            ref_key: "userRef",
            ref: userRef,
            class: "app-header__user",
            style: normalizeStyle({
              visibility: unref(isMobileCompactActive) && unref(isMenuOpen) ? "hidden" : "visible"
            }),
            onPointerdownCapture: handleUserInteractionCapture,
            onTouchstartCapture: handleUserInteractionCapture,
            onClickCapture: handleUserInteractionCapture,
            onPointerdown: _cache[9] || (_cache[9] = withModifiers(() => {
            }, ["stop"])),
            onClick: _cache[10] || (_cache[10] = withModifiers(() => {
            }, ["stop"])),
            onMousedown: _cache[11] || (_cache[11] = withModifiers(() => {
            }, ["stop"])),
            onTouchstart: _cache[12] || (_cache[12] = withModifiers(() => {
            }, ["stop"])),
            onTouchend: _cache[13] || (_cache[13] = withModifiers(() => {
            }, ["stop"]))
          }, [
            renderSlot(_ctx.$slots, "user", {}, () => [
              __props.showProfile ? (openBlock(), createBlock(ProfileDropdown, {
                key: 0,
                accounts: props.profileAccounts,
                "menu-items": props.profileMenuItems,
                "model-value": props.profileModelValue,
                searchable: props.profileSearchable,
                "search-placeholder": props.profileSearchPlaceholder,
                "user-name": props.userName || "",
                "user-email": props.userEmail,
                "user-avatar": props.userAvatar,
                "is-admin": props.isAdmin,
                "display-mode": unref(profileDisplayMode),
                "max-width": "300px",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = (val) => emit("profile:update:modelValue", val)),
                onSelect: _cache[8] || (_cache[8] = (account) => emit("profile:select", account))
              }, null, 8, ["accounts", "menu-items", "model-value", "searchable", "search-placeholder", "user-name", "user-email", "user-avatar", "is-admin", "display-mode"])) : createCommentVNode("", true)
            ], true)
          ], 36)
        ]),
        (unref(currentSecondaryItems).length || _ctx.$slots["secondary-nav"]) && !unref(isMenuOpen) ? (openBlock(), createElementBlock("div", _hoisted_14, [
          createElementVNode("div", _hoisted_15, [
            createElementVNode("nav", {
              ref_key: "secondaryNavRef",
              ref: secondaryNavRef,
              class: "app-header__secondary-nav"
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(visibleSecondaryItems), (item) => {
                return openBlock(), createElementBlock("button", {
                  key: item.name,
                  class: normalizeClass(["app-header__secondary-item", {
                    "app-header__secondary-item--active": unref(currentActiveSecondaryItem) === item.name
                  }]),
                  onClick: ($event) => handleSecondaryItemClick(item)
                }, [
                  createElementVNode("span", _hoisted_17, toDisplayString(item.label), 1)
                ], 10, _hoisted_16);
              }), 128)),
              unref(dropdownSecondaryItems)?.length ? (openBlock(), createBlock(Dropdown, { key: 0 }, {
                dropdown: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(dropdownSecondaryItems), (item) => {
                    return openBlock(), createBlock(DropdownItem, {
                      key: item.name,
                      onClick: ($event) => handleSecondaryItemClick(item)
                    }, {
                      default: withCtx(() => [
                        createElementVNode("div", _hoisted_20, [
                          createElementVNode("span", null, toDisplayString(item.label), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]);
                  }), 128))
                ]),
                default: withCtx(() => [
                  createElementVNode("button", _hoisted_18, [
                    createElementVNode("span", _hoisted_19, toDisplayString(__props.menuButtonLabel), 1),
                    createVNode(unref(ChevronDownIcon), { class: "app-header__more-icon" })
                  ])
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ], 512)
          ])
        ])) : createCommentVNode("", true),
        createVNode(Transition, { name: "mega-menu-fade" }, {
          default: withCtx(() => [
            unref(isMenuOpen) && unref(shouldShowMenuButton) ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "app-header__mega-menu-wrapper",
              style: normalizeStyle(unref(megaMenuStyles))
            }, [
              renderSlot(_ctx.$slots, "mega-menu", {
                closeMenu,
                groupedMenuItems: unref(groupedMenuItems),
                currentActiveSecondaryItem: unref(currentActiveSecondaryItem),
                handleSecondaryItemClick
              }, () => [
                createElementVNode("div", _hoisted_21, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(groupedMenuItems), (group) => {
                    return openBlock(), createElementBlock("div", {
                      key: group.category,
                      class: "app-header__mega-menu-column"
                    }, [
                      createElementVNode("div", _hoisted_22, [
                        group.icon ? (openBlock(), createBlock(resolveDynamicComponent(group.icon), {
                          key: 0,
                          class: "app-header__mega-menu-icon"
                        })) : createCommentVNode("", true),
                        createElementVNode("span", null, toDisplayString(group.category), 1)
                      ]),
                      createElementVNode("div", _hoisted_23, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(group.items, (item) => {
                          return openBlock(), createElementBlock("button", {
                            key: item.name,
                            class: normalizeClass(["app-header__mega-menu-item", {
                              "app-header__mega-menu-item--active": unref(currentActiveSecondaryItem) === item.name
                            }]),
                            onClick: ($event) => handleSecondaryItemClick(item)
                          }, toDisplayString(item.label), 11, _hoisted_24);
                        }), 128))
                      ])
                    ]);
                  }), 128))
                ])
              ], true)
            ], 4)) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 16);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AppHeader.vue2.js.map
